import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, IconButton, CircularProgress } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage  } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { FeeActions, NotificationActions } from '../../../store';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import jaLocale from 'date-fns/locale/ja';
import FilterDatePicker from './FilterDatePicker';

const style = theme => ({
    root: {
        height: '100%'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const feeSelector = (state) => state.Fees;
const IdentitySelector = (state) => state.Identity;

const FeeManagementList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const feeActions = bindActionCreators(FeeActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(feeSelector);

  
    const { token } = useSelector(IdentitySelector);

    const { classes } = props;

    var merchantName = props.merchantName;  // 加盟店名
    var merchantType = props.merchantType;  // 加盟店タイプ
    var period = props.period;              // 対象日付
    var creditCardPaymentAgencyId = props.credit_card_payment_agency_id; //ショップ

    const listDefinition = {
        columns: [
            {
                // 加盟店名
                title: <FormattedMessage id="FeeManagement.MerchantName" />,
                field: 'merchant_name',
                filtering: true,
                defaultFilter: props.merchantName,
            },
            {
                // 加盟店タイプ
                title: <FormattedMessage id="FeeManagement.MerchantType" />,
                field: 'merchant_type',
                lookup: {
                     "acquirer": "代表",
                     "general": "一般",
                },
                filtering: true,
                defaultFilter: props.merchantType,
            },
            {
                // 対象日付
                title: <FormattedMessage id="FeeManagement.TargetDay" />,
                field: 'period',
                filterComponent: (props) => (
                    <FilterDatePicker
                        columnDef={props.columnDef}
                        onFilterChanged={props.onFilterChanged}
                    />
                ),
                defaultFilter: props.period,
                customFilterAndSearch: (filterValue, rowData) => {
                    
                    var data = rowData.period;
                    var dates = data.split("～"); 

                    var dateFrom = dates[0].trim(); //yyyy/MM/ddフォーマット
                    var dateTo = dates[1].trim();   //yyyy/MM/ddフォーマット
                    var dateCheck = filterValue;    //yyyy-MM-ddフォーマット
                    
                    var d1 = dateFrom.split("/");
                    var d2 = dateTo.split("/");
                    var c = dateCheck.split("-");

                    var from = new Date(d1[0], d1[1], d1[2]);  
                    var to = new Date(d2[0], d2[1], d2[2]);
                    var check = new Date(c[0], c[1], c[2]);

                    //console.log(from);
                    //console.log(to);
                    //console.log(check);

                    if (check >= from && check <= to) {
                        return true;
                    } 
                },
            },
            {
                // ショップ
                title: <FormattedMessage id="Merchant.Shop" />,
                field: 'credit_card_payment_agency_id',
                lookup: {
                    "100002": "一般店舗",
                    "100003": "タクシー ",
                    "100004": "大規模小売",
                },
                filtering: true,
                defaultFilter: props.credit_card_payment_agency_id,
            },
        ]
    };

    /**
     *
     * フィルター変更時
     *
     * @param filter フィルターデータ配列
     */
    const onChangeFilter = (filter) => {

        merchantName = '';
        merchantType = '';
        period = '';
        creditCardPaymentAgencyId = '';

        if (filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                if (filter[i].column.field == 'merchant_name') {
                    merchantName = filter[i].value;
                } else if (filter[i].column.field == 'merchant_type') {
                    merchantType = filter[i].value;
                } else if (filter[i].column.field == 'period') {
                    period = filter[i].value;
                } else if (filter[i].column.field == 'credit_card_payment_agency_id') {
                    creditCardPaymentAgencyId = filter[i].value;
                }
            };
        }
        //console.log("merchantName=" + merchantName);
        //console.log("merchantType=" + merchantType);
        //console.log("period=" + period);
        //console.log("creditCardPaymentAgencyId=" + creditCardPaymentAgencyId);
    }

    /**
     *
     * Similar to componentDidMount and componentDidUpdate:
     * 
     * 第2引数に[]を渡すとマウント時のみ呼び出される
     */
    useEffect(() => {
        // 初期レンダリングの時のみ手数料設定一覧を取得
        if (props.refresh == null || props.refresh == true) {
            // storeに手数料設定リストを要求
            // 手数料設定一覧を取得
            feeActions.listFees(token)
                .then(data => {
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }

    }, []);

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDetailClick = (data, merchantName, merchantType, period, creditCardPaymentAgencyId) => {
        props.onDetail(data, merchantName, merchantType, period, creditCardPaymentAgencyId);
    }

    /**
     * 
     * 新規ボタン押下時の処理
     * 
     */
    const onCreateClick = (merchantName, merchantType, period, creditCardPaymentAgencyId) => {
        props.onCreate(merchantName, merchantType, period, creditCardPaymentAgencyId);
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={jaLocale}>
                <MaterialTable
                    title={<Typography component="h1" variant="inherit">{<FormattedMessage id="FeeManagement.List" />}</Typography>}
                    onFilterChange={(filter) => onChangeFilter(filter)}
                    columns={listDefinition.columns}
                    data={list}
                    options={{
                        search: false,
                        filtering: true,
                        actionsColumnIndex: -1
                    }}
                    localization={{
                        body: {
                            emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                        },
                        header: {
                            actions: ''
                        },
                    }}
                    components={{
                        Action: actionProps => {
                            if (actionProps.action.tooltip !== "Add") {
                                return (
                                    <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data, merchantName, merchantType, period, creditCardPaymentAgencyId)}>
                                        <ArrowForwardIosIcon />
                                    </IconButton>
                                )
                            } else {
                                return (
                                    <Button onClick={() => onCreateClick(merchantName, merchantType, period, creditCardPaymentAgencyId)} variant="contained" color="secondary" size="medium" startIcon={<AddCircleOutlineIcon />} >
                                        <FormattedMessage id="Button.AddFeeSettings" />
                                    </Button>
                                )
                            }
                        }
                    }}
                    editable={{
                        onRowAdd: newData => { },
                        onRowUpdate: (newData, oldData) => { }
                    }}
                />
            </MuiPickersUtilsProvider>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(FeeManagementList);
